<template>
   <div class="body-container">
      <Header />
      <Main />
      <Footer />
   </div>
</template>
<script>
import Header from './header.vue';
import Footer from './footer.vue';
import Main from './main.vue';
export default {
   name: "FuSheng",
   components: {
      Header,
      Footer,
      Main
   }
};
</script>

<style scoped>
.body-container{
   padding: 0px;
}
</style>

<style>
/*阿里巴巴普惠体 2.0*/
/* @font-face {
  font-family: "AlibabaPuHuiTi-Thin";font-weight:4000;
  src: url("../assets/fonts/AlibabaPuHuiTi-2-45-Light.ttf");
}
@font-face {
  font-family: "AlibabaPuHuiTi-Light";
  src: url("../assets/fonts/AlibabaPuHuiTi-2-45-Light.ttf");
}
@font-face {
  font-family: "AlibabaPuHuiTi-Regular";
  src: url("../assets/fonts/AlibabaPuHuiTi-2-55-Regular.ttf");
} */

@font-face {
  font-family: "AlibabaPuHuiTi-Thin";font-weight:400;
  src: url("../assets/fonts/AlibabaPuHuiTi-2-35-Thin.woff2") format("woff2");
  font-display: swap;
}
@font-face {
  font-family: "AlibabaPuHuiTi-Light";font-weight:400;
  src: url("../assets/fonts/AlibabaPuHuiTi-2-45-Light.woff2") format("woff2");
  font-display: swap;
}
@font-face {
  font-family: "AlibabaPuHuiTi-Regular";font-weight:400;
  src: url("../assets/fonts/AlibabaPuHuiTi-2-55-Regular.woff2") format("woff2");
  font-display: swap;
}


body{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
h1{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
h2{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
h3{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
h4{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
p{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
span{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
a{
   font-family: AlibabaPuHuiTi-Light,SimHei,Heiti,sans-serif,system-ui,Helvetica,Tahoma,Arial;
}
</style>